import { motion } from "framer-motion";
import React from "react";
import styled from "styled-components";

/* ================= CARD BOX ================= */

const Box = styled(motion.a)`
  box-sizing: border-box;

  width: 100%;     /* 🔥 VERY IMPORTANT */
  height: 22rem;     /* Slight increase for balance */

  text-decoration: none;
  padding: 1rem;

color: ${(props) => (props.$lc ? "#fff" : props.theme.text)};
  border: 2px solid ${(props) => props.theme.text};

    /* 🔥 LC background black */
  background-color: ${(props) => (props.$lc ? "#000" : "transparent")};
  backdrop-filter: blur(2px);
  box-shadow: 0 0 1rem 0 rgba(0, 0, 0, 0.2);

  cursor: pointer;

  display: flex;
  flex-direction: column;
  justify-content: center;

  z-index: 5;
  transition: all 0.3s ease;

  &:hover {
    color: ${(props) => props.theme.body};
    background-color: ${(props) => props.theme.text};
  }

/* ===== BETWEEN 426px and 768px ===== */
@media (min-width: 426px) and (max-width: 768px) {
  width: 60vw;     /* 👈 Screenshot la irukura approx width */
  height: 22rem;
}
  

@media (min-width: 769px) and (max-width: 1024px) {
  width: 18.5rem;
  height:23rem ;        /* 🔥 remove fixed height */
  min-height: 19rem;   /* keep structure balance */
  margin: 0 auto;
  padding: 0.9rem;
}



/* ===== 380px ===== */
@media (max-width: 380px) {
  width: 250px;
}

/* ===== 330px ===== */
@media (max-width: 330px) {
  width: 227px;
}

@media (max-width: 376px) {
  height: auto;
}

`;

/* ================= IMAGE ================= */

const Image = styled.div`
  background-image: ${(props) => `url(${props.img})`};
  width: 100%;

  /* 🔥 LC card only responsive height */
  height: ${(props) => (props.full ? "auto" : "180px")};

  /* 🔥 Maintain proper ratio only for LC */
  aspect-ratio: ${(props) => (props.full ? "16 / 9" : "auto")};

  background-size: ${(props) => (props.full ? "contain" : "cover")};
  background-repeat: no-repeat;
  background-position: center;
  border-radius: 6px;

  ${Box}:hover & {
    border: 1px solid ${(props) => props.theme.body};
  }
`;

/* ================= TITLE ================= */

const Title = styled.h3`
  color: inherit;
  padding: 0.5rem 0;
  padding-top: 1rem;

  font-family: "Karla", sans-serif;
  font-weight: 700;

  border-bottom: 1px solid ${(props) => props.theme.text};

  ${Box}:hover & {
    border-bottom: 1px solid ${(props) => props.theme.body};
  }

  @media (max-width: 426px) {
  font-size: 0.9rem;
}

@media (max-width: 376px) {
  font-size: 0.8rem;
  line-height: 1.2;
  word-break: break-word;
}

@media (min-width: 769px) and (max-width: 1024px) {
  font-size: 0.95rem;
  line-height: 1.2;
}
`;

/* ================= TAGS ================= */

const HashTags = styled.div`
  padding: 0.5rem 0;

  @media (min-width: 769px) and (max-width: 1024px) {
  flex-wrap: wrap;
}
`;

const Tag = styled.span`
  padding-right: 0.5rem;


  @media (max-width: 426px) {
  font-size: 0.75rem;
}

@media (max-width: 376px) {
  font-size: 0.7rem;
  word-break: break-word;
}

@media (min-width: 769px) and (max-width: 1024px) {
  font-size: 0.75rem;
}
`;

/* ================= DATE ================= */

const Date = styled.span`
  padding: 0.5rem 0;

  @media (max-width: 426px) {
  font-size: 0.75rem;
}

@media (max-width: 376px) {
  font-size: 0.7rem;
}

@media (min-width: 769px) and (max-width: 1024px) {
  font-size: 0.75rem;
  white-space: nowrap;
    margin-top: 0.5rem;
}
`;

/* ================= FRAMER MOTION ================= */

const Container = styled(motion.div)`
  /* ===== 376px to 425px ONLY ===== */
  @media (min-width: 376px) and (max-width: 425px) {
    width: 290px;
    margin: 0 auto;
  }
`;

const Item = {
  hidden: {
    scale: 0,
  },
  show: {
    scale: 1,
    transition: {
      type: "spring",
      duration: 0.5,
    },
  },
};

const ImageWrapper = styled.div`
  background:transparent;
`;

const SpecialTitle = styled.h3`
  text-align: center;
  padding: 1rem;
  font-size: 1.2rem;
  font-weight: 600;
`;

/* ================= COMPONENT ================= */

const BlogComponent = (props) => {
  const { id, name, tags, date, imgSrc, link } = props.blog;

  return (
    <Container variants={Item}>
      {id === 1 ? (

        // 🔥 Special LeetCode Card
        <Box target="_blank" href={link} $lc>
          <ImageWrapper>
            <Image img={imgSrc} full />
          </ImageWrapper>

          <SpecialTitle>
            Leetcode coding profile
          </SpecialTitle>
        </Box>

      ) : (

        // 🔥 Normal Cards
        <Box target="_blank" href={link}>
          <ImageWrapper>
            <Image img={imgSrc} />
          </ImageWrapper>

          <Title>{name}</Title>

          <HashTags>
            {tags.map((t, index) => (
              <Tag key={index}>#{t}</Tag>
            ))}
          </HashTags>

          <Date>{date}</Date>
        </Box>

      )}
    </Container>
  );
};

export default BlogComponent;
